export const CALENDAR_DATE_STATUS = {
  SELECTED: 'selected',
  EXISTING: 'existing',
  EDITING: 'editing',
  NONE: null
} as const

export const CALENDAR_DATE_STYLES = {
  [CALENDAR_DATE_STATUS.SELECTED]: {
    backgroundColor: '#dbeafe',
    color: '#1d4ed8',
    cursor: 'pointer'
  },
  [CALENDAR_DATE_STATUS.EXISTING]: {
    backgroundColor: '#dcfce7',
    color: '#166534',
    cursor: 'pointer'
  },
  [CALENDAR_DATE_STATUS.EDITING]: {
    backgroundColor: '#dbeafe',
    color: '#1d4ed8',
    cursor: 'not-allowed'
  },
  DISABLED: {
    backgroundColor: '#f3f4f6',
    color: '#9ca3af',
    cursor: 'not-allowed'
  },
  HOLIDAY: {
    color: '#ef4444',
    backgroundColor: 'transparent',
    cursor: 'pointer'
  },
  DEFAULT: {
    backgroundColor: 'transparent',
    color: 'inherit',
    cursor: 'pointer'
  }
} as const

export type CalendarDateStatus =
  (typeof CALENDAR_DATE_STATUS)[keyof typeof CALENDAR_DATE_STATUS]
